import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { RequestVM } from 'civil-status/view-models/step-form';
import { useFormikContext } from 'formik';
import { memo, useMemo } from 'react';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { ItemVM } from 'shell/view-models/item';

interface SelectRequestProps {
  request?: RequestVM;
  required?: boolean;
  disabled?: boolean;
}

const SelectRequestComponent = ({
  request,
  required,
  disabled,
}: SelectRequestProps): React.ReactElement => {
  const label = request?.request || '';

  const formContext = useFormikContext<Record<string, string | boolean>>();

  const name = request?.name || '';

  const error = useMemo(() => {
    return (
      formContext.touched &&
      formContext.touched[name] &&
      formContext.errors &&
      Boolean(formContext.errors[name])
    );
  }, [formContext.touched, formContext.errors]);

  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} id={`label-${label}`}>
        {required ? `${label} *` : label || undefined}
      </InputLabel>
      <PmiSelect
        labelId={`label-${label}`}
        id={`id-${label}`}
        name={`id-${label}`}
        value={formContext.values[name]?.toString()}
        label={required ? `${label} *` : label || undefined}
        error={error}
        disabled={disabled}
        onChange={(event: SelectChangeEvent<string>) => {
          formContext.setValues({
            ...(formContext.values || {}),
            [name]: event.target.value || '',
          });
        }}
      >
        {request?.options?.map((item: ItemVM) => (
          <MenuItem key={item.id} value={item.id}>
            {item.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

SelectRequestComponent.displayName = 'Select Request component';

const SelectRequest = memo(SelectRequestComponent);

export default SelectRequest as typeof SelectRequestComponent;
